import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const INITIAL_STATE = {
  consumerDetails: {},
  // Profile Details
  updateConsumer: {
    data: {},
    success: false,
  },
  verifyAccount: {
    data: {},
    verify: false,
  },
  uploadConsumerImg: {
    data: {},
    success: false,
  },
  SMSSent: false,
  updatePhoneNoSuccess: false,
  codeVerified: false,
  // Address
  consumerAddressList: [],
  addAddressSuccess: false,
  updateAddressSuccess: false,
  deleteAddressSuccess: false,
  consumerDeliveryFee: {},
  getAddressListSuccess: false,
  // Change Password
  changePasswordSuccess: false,
  // Restaurant Order
  myRestaurantOrder: {
    All: {
      data: [],
      offset: 0,
      limit: 10,
      isLoading: false,
      meta: {
        page: 1,
        pageSize: 0,
        pageTotal: 1,
        total: 0,
        pageSizeOptions: [5, 10, 20, 30, 50, 100],
      },
    },
    Upcoming: {
      data: [],
      offset: 0,
      limit: 10,
      isLoading: false,
      meta: {
        page: 1,
        pageSize: 0,
        pageTotal: 1,
        total: 0,
        pageSizeOptions: [5, 10, 20, 30, 50, 100],
      },
    },
    Refund: {
      data: [],
      offset: 0,
      limit: 10,
      isLoading: false,
      meta: {
        page: 1,
        pageSize: 0,
        pageTotal: 1,
        total: 0,
        pageSizeOptions: [5, 10, 20, 30, 50, 100],
      },
    },
    History: {
      data: [],
      offset: 0,
      limit: 10,
      isLoading: false,
      meta: {
        page: 1,
        pageSize: 0,
        pageTotal: 1,
        total: 0,
        pageSizeOptions: [5, 10, 20, 30, 50, 100],
      },
    },
  },
  //Restaurant Order Details
  myRestaurantOrderDetail: {},
  cancelRestaurantOrder: false,
  completeRestaurantOrder: false,
  // Restaurant Order Review
  consumerResOrderReview: {
    data: {},
    success: false,
  },
  consumerResRiderReview: {
    data: {},
    success: false,
  },
  // Wallet Pin
  setWalletPinSuccess: false,
  // Become Merchant
  becomeMerchantData: {
    step: 0,
    fields: {},
  },
  becomeMerchantSubmitting: false,
  becomeMerchantSuccess: false,
  becomeMerchantCaseID: "",
  voucherQuantity: 1,
  shownMFAlert: false,
};

export default function consumerReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.SHOWN_MF_ALERT:
      return { ...state, shownMFAlert: true };
    case actionTypes.STORE_QUANTITY:
      return { ...state, voucherQuantity: action.data };
    case actionTypes.CLEAR_QUANTITY:
      return { ...state, voucherQuantity: 1 };
    // GetConsumerDetails
    case actionTypes.GET_CONSUMER_DETAILS: {
      return {
        ...state,
      };
    }
    case actionTypes.GET_CONSUMER_DETAILS_SUCCESS: {
      return {
        ...state,
        consumerDetails: action.data,
      };
    }

    //UpdateConsumer
    case actionTypes.UPDATE_CONSUMER: {
      return {
        ...state,
      };
    }
    case actionTypes.UPDATE_CONSUMER_SUCCESS: {
      return {
        ...state,
        updateConsumer: {
          data: action.data,
          success: true,
        },
      };
    }
    case actionTypes.UPDATE_CONSUMER_FAIL: {
      return {
        ...state,
        updateConsumer: {
          data: action.data,
          success: false,
        },
      };
    }
    // VerifyConsumerAccount
    case actionTypes.VERIFY_CONSUMER_ACC: {
      return {
        ...state,
      };
    }
    case actionTypes.VERIFY_CONSUMER_ACC_SUCCESS: {
      let verifyAccount = { ...state.verifyAccount };
      verifyAccount.data = action.data;
      verifyAccount.verify = true;

      return {
        ...state,
        verifyAccount: verifyAccount,
      };
    }
    case actionTypes.VERIFY_CONSUMER_ACC_FAIL: {
      let verifyAccount = { ...state.verifyAccount };
      verifyAccount.data = action.data;
      verifyAccount.verify = false;
      return {
        ...state,
        verifyAccount: verifyAccount,
      };
    }
    // UploadProfileImage
    case actionTypes.UPLOAD_CONSUMER_IMG: {
      return {
        ...state,
      };
    }
    case actionTypes.UPLOAD_CONSUMER_IMG_SUCCESS: {
      let uploadConsumerImg = { ...state.uploadConsumerImg };
      uploadConsumerImg.data = action.data;
      uploadConsumerImg.success = true;
      return {
        ...state,
        uploadConsumerImg: uploadConsumerImg,
      };
    }
    // SendSMS
    case actionTypes.CHANGE_PHONE_NO_SENT_SMS:
    case actionTypes.CHANGE_PHONE_NO_SENT_SMS_FAIL: {
      return {
        ...state,
        SMSSent: false,
        codeVerified: false,
      };
    }
    case actionTypes.CHANGE_PHONE_NO_SENT_SMS_SUCCESS: {
      return {
        ...state,
        SMSSent: true,
        codeVerified: false,
      };
    }
    // Verify SMS
    case actionTypes.CHANGE_PHONE_NO_VERIFY_SMS:
    case actionTypes.CHANGE_PHONE_NO_VERIFY_SMS_FAIL:
      return {
        ...state,
        SMSSent: false,
        codeVerified: false,
      };

    case actionTypes.CHANGE_PHONE_NO_VERIFY_SMS_SUCCESS:
      return {
        ...state,
        SMSSent: false,
        codeVerified: true,
      };

    // UPDATE PHONE NO
    case actionTypes.CHANGE_PHONE_NO_UPDATE:
    case actionTypes.CHANGE_PHONE_NO_UPDATE_FAIL:
      return {
        ...state,
        SMSSent: false,
        updatePhoneNoSuccess: false,
      };
    case actionTypes.CHANGE_PHONE_NO_UPDATE_SUCCESS:
      return {
        ...state,
        SMSSent: false,
        codeVerified: false,
        updatePhoneNoSuccess: true,
      };
    // Get Delivery Fee
    case actionTypes.GET_DELIVERY_FEE: {
      return { ...state };
    }
    case actionTypes.GET_DELIVERY_FEE_SUCCESS: {
      return {
        ...state,
        consumerDeliveryFee: action.data,
      };
    }
    case actionTypes.GET_DELIVERY_FEE_FAIL: {
      return {
        ...state,
      };
    }
    // Address
    // GetConsumerAddress
    case actionTypes.GET_CONSUMER_ADDRESS: {
      return { ...state };
    }
    case actionTypes.GET_CONSUMER_ADDRESS_SUCCESS: {
      return {
        ...state,
        consumerAddressList: action.data,
        getAddressListSuccess: true,
      };
    }
    case actionTypes.GET_CONSUMER_ADDRESS_FAIL: {
      return {
        ...state,
      };
    }

    case actionTypes.ADD_CONSUMER_ADDRESS:
    case actionTypes.ADD_CONSUMER_ADDRESS_FAIL: {
      return {
        ...state,
        addAddressSuccess: false,
      };
    }
    case actionTypes.ADD_CONSUMER_ADDRESS_SUCCESS: {
      return {
        ...state,
        addAddressSuccess: true,
      };
    }

    case actionTypes.UPDATE_CONSUMER_ADDRESS:
    case actionTypes.UPDATE_CONSUMER_ADDRESS_FAIL: {
      return {
        ...state,
        updateAddressSuccess: false,
      };
    }
    case actionTypes.UPDATE_CONSUMER_ADDRESS_SUCCESS: {
      return {
        ...state,
        updateAddressSuccess: true,
      };
    }

    case actionTypes.DELETE_CONSUMER_ADDRESS:
    case actionTypes.DELETE_CONSUMER_ADDRESS_FAIL: {
      return {
        ...state,
        deleteAddressSuccess: false,
      };
    }
    case actionTypes.DELETE_CONSUMER_ADDRESS_SUCCESS: {
      return {
        ...state,
        deleteAddressSuccess: true,
      };
    }
    // Change Password
    case actionTypes.CHANGE_PASSWORD:
    case actionTypes.CHANGE_PASSWORD_FAIL: {
      return {
        ...state,
        changePasswordSuccess: INITIAL_STATE.changePasswordSuccess,
      };
    }
    case actionTypes.CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        changePasswordSuccess: true,
      };
    }
    // My Restauramt Order List
    case actionTypes.RESTAURANT_CONSUMER_ORDER: {
      let myRestaurantOrder = { ...state.myRestaurantOrder };

      myRestaurantOrder[action.status].offset = action.data.offset;
      myRestaurantOrder[action.status].limit = action.data.limit;
      myRestaurantOrder[action.status].isLoading = true;
      if (action.data.offset === 0) {
        myRestaurantOrder[action.status].data = [];
      }
      return {
        ...state,
        myRestaurantOrder: myRestaurantOrder,
      };
    }
    case actionTypes.RESTAURANT_CONSUMER_ORDER_SUCCESS: {
      let myRestaurantOrder = { ...state.myRestaurantOrder };
      myRestaurantOrder[action.status].data = action.data.data;
      myRestaurantOrder[action.status].isLoading = false;
      myRestaurantOrder[action.status].meta = {
        page:
          1 +
          myRestaurantOrder[action.status].offset /
            myRestaurantOrder[action.status].limit,
        pageSize: myRestaurantOrder[action.status].limit,
        pageTotal: Math.ceil(
          action.data.recordsTotal / myRestaurantOrder[action.status].limit
        ),
        total: action.data.recordsTotal,
      };
      return {
        ...state,
        myRestaurantOrder,
      };
    }
    // My Restaurant Order Details
    case actionTypes.RESTAURANT_CONSUMER_ORDER_DETAIL: {
      return {
        ...state,
      };
    }
    case actionTypes.RESTAURANT_CONSUMER_ORDER_DETAIL_SUCCESS: {
      return {
        ...state,
        myRestaurantOrderDetail: action.data,
      };
    }
    // My Restaurant Cancel Order
    case actionTypes.RESTAURANT_CONSUMER_CANCEL_ORDER: {
      return {
        ...state,
        cancelRestaurantOrder: false,
      };
    }
    case actionTypes.RESTAURANT_CONSUMER_CANCEL_ORDER_SUCCESS: {
      return {
        ...state,
        cancelRestaurantOrder: true,
      };
    }
    // Restaurant Complete Order
    case actionTypes.RESTAURANT_CONSUMER_COMPLETE_ORDER: {
      return {
        ...state,
        completeRestaurantOrder: false,
      };
    }
    case actionTypes.RESTAURANT_CONSUMER_COMPLETE_ORDER_SUCCESS: {
      return {
        ...state,
        completeRestaurantOrder: true,
      };
    }
    // Restaurant Order Review
    case actionTypes.RESTAURANT_ORDER_REVIEW: {
      return {
        ...state,
        consumerResOrderReview: {
          data: {},
          success: false,
        },
      };
    }
    case actionTypes.RESTAURANT_ORDER_REVIEW_SUCCESS: {
      return {
        ...state,
        consumerResOrderReview: {
          data: {},
          success: true,
        },
      };
    }
    // Restaurant Rider Review
    case actionTypes.RESTAURANT_ORDER_RIDER_REVIEW: {
      return {
        ...state,
        consumerResRiderReview: {
          data: {},
          success: false,
        },
      };
    }
    case actionTypes.RESTAURANT_ORDER_RIDER_REVIEW_SUCCESS: {
      return {
        ...state,
        consumerResRiderReview: {
          data: {},
          success: true,
        },
      };
    }
    // Wallet Pin
    case actionTypes.SET_WALLET_PIN:
    case actionTypes.SET_WALLET_PIN_FAIL: {
      return {
        ...state,
        setWalletPinSuccess: false,
      };
    }
    case actionTypes.SET_WALLET_PIN_SUCCESS: {
      return {
        ...state,
        setWalletPinSuccess: true,
      };
    }

    // Become Merchant
    case actionTypes.STORE_BECOME_MERCHANT_DATA: {
      return {
        ...state,
        becomeMerchantData: action.data,
      };
    }
    case actionTypes.BECOME_MERCHANT: {
      return {
        ...state,
        becomeMerchantSubmitting: true,
        becomeMerchantSuccess: false,
      };
    }
    case actionTypes.BECOME_MERCHANT_SUCCESS: {
      return {
        ...state,
        becomeMerchantData: INITIAL_STATE.becomeMerchantData,
        becomeMerchantSubmitting: false,
        becomeMerchantSuccess: true,
      };
    }
    case actionTypes.BECOME_MERCHANT_FAIL: {
      return {
        ...state,
        becomeMerchantSubmitting: false,
        becomeMerchantSuccess: false,
      };
    }
    case actionTypes.BECOME_MERCHANT_TWO: {
      return {
        ...state,
        becomeMerchantSubmitting: true,
        becomeMerchantSuccess: false,
        becomeMerchantCaseID: "",
      };
    }
    case actionTypes.BECOME_MERCHANT_TWO_SUCCESS: {
      //   console.log(action.data);
      return {
        ...state,
        becomeMerchantData: INITIAL_STATE.becomeMerchantData,
        becomeMerchantSubmitting: false,
        becomeMerchantSuccess: true,
        becomeMerchantCaseID: action.data,
      };
    }
    case actionTypes.BECOME_MERCHANT_TWO_FAIL: {
      return {
        ...state,
        becomeMerchantSubmitting: false,
        becomeMerchantSuccess: false,
        becomeMerchantCaseID: "",
      };
    }
    case actionTypes.CHECK_PAYMENT_CODE_SUCCESS: {
      let becomeMerchantData = cloneDeep(state.becomeMerchantData);
      becomeMerchantData.fields.code1 = action.code1;
      becomeMerchantData.fields.code2 = action.code2;

      return {
        ...state,
        becomeMerchantData,
      };
    }
    default:
      return state;
  }
}
